import {
  Component,
  ComponentInterface,
  h,
  State,
  Event,
  EventEmitter,
} from "@stencil/core";
import { KEY_TIME_IN_QUEUE } from "../../../models";
import {
  StorageService,
  AppConfigService as Config,
  ErrorHandler,
  CommonService,
  TranslateService,
} from "../../../services";
import { NotificationService } from "../../../services/notification.service";

@Component({
  tag: "av-timer",
  styleUrl: "av-timer.css",
  shadow: true,
})
export class AvTimer implements ComponentInterface {
  @State() state = {
    minutes: "00",
    seconds: "00",
  };

  @Event() changed: EventEmitter<{ seconds: string; minutes: string }>;

  private timerInterval = 0;
  private totalSeconds = 0;

  componentDidLoad() {
    const existingTime = Number(
      StorageService.getItem(KEY_TIME_IN_QUEUE, "session")
    );
    if (existingTime) {
      this.totalSeconds = existingTime;
      this.setTime();
    }
    this.timerInterval = CommonService.timer.setInterval(
      () => this.setTime(),
      1000
    );
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      try {
        CommonService.timer.clearInterval(this.timerInterval);
      } catch (ex) {
        ErrorHandler.captureError(ex);
      } finally {
        this.timerInterval = 0;
      }
    }
    this.totalSeconds = 0;
    NotificationService.announceVoiceOverMessage(null);
  }

  setTime() {
    ++this.totalSeconds;
    this.state = {
      seconds: this.pad(this.totalSeconds % 60),
      minutes: this.pad(Math.floor(Number(this.totalSeconds / 60))),
    };
    if (Config.canPopOut) {
      StorageService.setItem(KEY_TIME_IN_QUEUE, this.totalSeconds, "session");
    }
    if (this.totalSeconds % 15 === 0) {
      const seconds = this.totalSeconds % 60;
      const minutes = Math.floor(Number(this.totalSeconds / 60));
      let message = [TranslateService.instant("Time")];
      if (minutes > 0) {
        message = [
          ...message,
          String(minutes),
          TranslateService.instant(minutes === 1 ? "minute" : "minutes"),
        ];
      }
      if (seconds > 0) {
        message = [
          ...message,
          String(seconds),
          TranslateService.instant("seconds"),
        ];
      }
      NotificationService.announceVoiceOverMessage(message.join(" "));
    }
    if (this.state.seconds) this.changed.emit(this.state);
  }

  pad(val) {
    const valString = val + "";
    return valString.length < 2 ? "0" + valString : valString;
  }

  render() {
    return (
      <div
        role="timer"
        aria-hidden="true"
        aria-label={TranslateService.instant("Elapsed time")}
        class="clock"
      >
        <div>{this.state.minutes}</div>
        <div>:</div>
        <div>{this.state.seconds}</div>
      </div>
    );
  }
}
